import {chainDepositTrack} from './utils';

/**
 * 记录链上入金，使用的钱包类型
 */
export function trackConnectType() {
  chainDepositTrack('connect-type', {});
}

/**
 * 记录下单时候提交数据
 */
export function trackCommit(params: any) {
  chainDepositTrack('confirm-data', params);
}

/**
 * 记录切换链
 */
export function trackUserChangeChain(params: {beforeChainId: number; beforeChainName: string; afterChainId: number; afterChainName: string}) {
  chainDepositTrack('change-chain', params);
}

/**
 * 记录切换链错误
 */
export function trackChangeChainError(error: {message: string; name: string}) {
  chainDepositTrack('change-chain-error', error);
}

/**
 * 记录添加链
 */
export function trackUserAddChain(params: {chainId: number; chainName: string}) {
  chainDepositTrack('add-chain', params);
}

/**
 * 记录添加链错误
 */
export function trackaddChainError(error: {message: string; name: string}) {
  chainDepositTrack('add-chain-error', error);
}

/**
 * 记录查询token的decimals错误
 */
export function trackgetDecimalsError(error: {message: string; name: string}) {
  chainDepositTrack('get-decimals-error', error);
}

/**
 * 记录交易成功数据
 */
export function trackTransactionSuccess(params: any) {
  chainDepositTrack('transaction-success', params);
}

/**
 * 记录交易失败数据
 */
export function trackPreTransactionError(error: {message: string; name: string}) {
  chainDepositTrack('pretransaction-error', error);
}

/**
 * 记录交易失败数据
 */
export function trackTransactionError(error: {message: string; name: string}) {
  chainDepositTrack('transaction-error', error);
}

/**
 * 记录未知错误
 */
export function trackTransactionUnknowError(error: {message: string; name: string}) {
  chainDepositTrack('transaction-unknow-error', error);
}

/**
 * 记录上账地址验签错误
 */
export function trackAddressCryptoError(params: any) {
  chainDepositTrack('address-crypto-error', params);
}
